import React, { Component, Fragment } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import $ from 'jquery';
import ReactTable from 'react-table';
import checkboxHOC from "react-table/lib/hoc/selectTable";
import { getTeachers, getTransactions, saveItemTransaction } from './bulkTransactionService';
import { _addNotification, _addNotificationError, groupBy } from '../../../../server/util';
import CustomSubmit from '../../../Misc/customSubmit';
import moment from 'moment';

const CheckboxTable = checkboxHOC(ReactTable);
class ItemListComponent extends Component {
    constructor(props){
        super(props);
        this.state={
            tabIndex:0,
            ttabIndex:0,
            selectedRows:[],
            selection: [],
            selectAll:false,
            data:[],
            filterData:[],
            search:'',
            teachers:{}
        }

    }
    
    componentDidMount=()=>{
        this.getTeachersList();       
    }
    getTeachersList=()=>{
        const {setLoading}=this.props;
        setLoading(true);
        getTeachers({
                schoolYear:sessionStorage.getItem('schoolYearValue'),
                schoolId:sessionStorage.getItem('SchoolId')
            }).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                setLoading(false);
                this.setState({
                    teachers:data.resp
                },()=>{
                    this.getData();
                })

            }).catch(error => {
                setLoading(false);
            console.log("Loading Report Failed", error);
        });
    }
   
    getCols=()=>{
        let columns=[];
        columns.push({
            accessor: 'mealName',
            Header: 'Meal Item Name',
            Cell: props => props.original.mealName,
            style: { textAlign: 'left' }
        }); 
       
        columns.push({
            Header: 'COUNT',
            width:150,
            Cell: ({ row }) => <input type="number" min='0' className={'form-control'} value={row._original.totalQty}  
            onChange={(event) => this.handleCountChange(row._original._id, event.target.value)}
             />,
            style: { textAlign: 'center' }
        });
        /* columns.push({
            accessor: 'totalQty',
            Header: 'Total Qty',
            width:150,
            Cell: props => props.original.totalQty,
            style: { textAlign: 'right', paddingRight:'30px' }
        });  */     
        return columns;
    }
    toggleSelection = (key, shift, row) => {
        let selection = [...this.state.selection];
        let selectedRows=[...this.state.selectedRows]
        const keyIndex = selection.indexOf(key);
        // check to see if the key exists
        if (keyIndex >= 0) {
            // it does exist so we will remove it using destructing
            selection = [
                ...selection.slice(0, keyIndex),
                ...selection.slice(keyIndex + 1)
            ];
            selectedRows=[
               ... selectedRows.slice(0,keyIndex),
                ...selectedRows.slice(keyIndex + 1)
            ]
        } else {
            // it does not exist so add it
            selection.push(key);
            selectedRows.push(row);
        }
        // update the state
        this.setState({ selection,selectedRows });
        this.setState({ selectAll: false });
    };
    toggleAll = () => {
        //alert('toggleAll')
        const selectAll = this.state.selectAll ? false : true;
        const selection = [];
        let selectedRows=[]
        if (selectAll) {
            // we need to get at the internals of ReactTable
            const wrappedInstance = this.checkboxTable.getWrappedInstance();
            // the 'sortedData' property contains the currently accessible records based on the filter and sort
            const currentRecords = wrappedInstance.getResolvedState().sortedData;
            //this.setState({studentCount: currentRecords.length});
            // we just push all the IDs onto the selection array
            //console.log(JSON.stringify(currentRecords,null,2))
            currentRecords.forEach(item => {
                selection.push(item._original._id);
                selectedRows.push(item._original)
            });
        }
        this.setState({ selectAll, selection,selectedRows });
    };
    isSelected = key => {
        const res=(this.state.selection||[]).find((item)=>{
            const _item=((item||'')+'').replace('select-','');
            return _item==key;
        });
        if(res){
            return true;
        }else{
            return false;
        }
    };
    getDate_MenuTypeChangeData=()=>{
        this.setState({tabIndex:0,ttabIndex:0,  selectedRows:[],
            selection: []},()=>{
            this.getData()
        });
    }

    getData=()=>{
        const {selectedDate,mealType, setLoading}=this.props;
        const {teachers}=this.state;
        const schoolId= sessionStorage.getItem('SchoolId'); 
        setLoading( true); 
        this.setState({tabIndex:0,ttabIndex:0,  selectedRows:[],
            selection: [],data:[],filterData:[]});       
        getTransactions({schoolId,mealType,selectedDate}).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            setLoading( false);
            let ordersGroup=((data.resp||{}).availableMenu||{});
            let finalDataArray=[];
            Object.keys(ordersGroup).map(grade=>{
                const gradeTeachers=((teachers||{})[grade]||[]);
                if(gradeTeachers.length<=0){
                    Object.keys(ordersGroup[grade]||{}).map(mtype=>{                        
                        finalDataArray=[...finalDataArray,...((ordersGroup[grade][mtype]||[]).map(item=>{
                            item.grade=grade;
                            item.mealType=mtype;
                            return item;
                        }))];
                    });
                }else{
                    let teacherMappedArray=[];
                    gradeTeachers.map(teacher=>{
                        Object.keys(ordersGroup[grade]||{}).map(mtype=>{    
                            ((ordersGroup[grade][mtype]||[]).map(rec=>{
                                rec.grade=grade;
                                rec.teacher=teacher||'';
                                rec.mealType=mtype;
                                teacherMappedArray.push({...rec});
                            }));
                        });
                    })
                    finalDataArray=[...finalDataArray,...teacherMappedArray]; 
                }
            });

            this.setState({ tabIndex:0,ttabIndex:0, data:finalDataArray.map((rec,i)=>{
                rec._id=(i+1);
                rec.editTotal=0;//rec.totalQty||0;
                rec.totalQty=0;
                return rec;
            })},()=>{
                this.filterOrderData(finalDataArray||[],0)
            });
        }).catch(error => {
            setLoading( false);
            console.log("Loading Report Failed", error);
        })
    }

    filterOrderData=(data,tabIndex=0,ttabIndex=0,search='')=>{
        const {teachers}=this.state;
        let list=[];
        const tabIndexVal=this.props.gradeList[tabIndex].value;         
       
            list= data.filter((rec)=>{
                return rec.grade==tabIndexVal;
            });
            const gradeByTeachers=((teachers||{})[tabIndexVal]||[]);
            let teacherFilter=[];
            if(gradeByTeachers.length>0){
                const ttabIndexVal=gradeByTeachers[ttabIndex];
                teacherFilter=list.filter(rec=>{
                    return rec.teacher==ttabIndexVal;
                });
            }else{
                teacherFilter=[...list];
            }
             
        this.setState({filterData: search.length>0? [...teacherFilter].filter(rec=>{
            return (rec.mealName||'').toUpperCase().startsWith(search.toUpperCase())
        }):[...teacherFilter] });
    }
    handleCountChange = (id, value) => {
        let tabData = this.state.data.map((item) => ({
            ...item,
            totalQty: item._id === id ? (value >= 0 ? parseInt(value) : 0) : item.totalQty,
        }));

        let _filterData = this.state.filterData.map((item) => {
            if (item._id === id) {
                return { ...item, totalQty: value >= 0 ? parseInt(value) : 0 };
            }
            return item;
        });
         const _selectedRows=this.state.selectedRows.map((item) => {
            if (item._id === id) {
                return { ...item, totalQty: value >= 0 ? parseInt(value) : 0 };
            }
            return item;
        });

        this.setState({ filterData: [..._filterData], 
            data: [...tabData], 
            selectedRows:[..._selectedRows] });
    };
    getSystemDateTime = () =>{
        const {selectedDate}=this.props;
        const selectedDateTime=moment(selectedDate).set( {
           hour:   moment().get('hour'),
           minute: moment().get('minute'),
           second: moment().get('second')
       })
       let _datetime=moment.utc(selectedDateTime).format('YYYY-MM-DDTH:mm:ss');
       return _datetime+'Z'; 
      // return moment(this.state.startDate).format('YYYY-MM-DD');
   }
    saveTransaction=(e,callback)=>{
        const {setLoading, mealType}=this.props;
        const {selectedRows}=this.state;
        e.preventDefault();
        if(selectedRows.length > 0){
            
            const systemDateTime=this.getSystemDateTime();
            let schoolId = sessionStorage.getItem('SchoolId');
            const loginUserInfo=JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
            const finalReqObj=[];

            const gradeGroup=groupBy(selectedRows,'grade');
            Object.keys(gradeGroup).map(grade=>{
                if(gradeGroup[grade].length>0){
                    const teacherGroup=groupBy(gradeGroup[grade]||[],'teacher');
                    Object.keys(teacherGroup).map(teacher=>{
                        const gradeObj={
                            grade: grade,
                            mealType: (mealType==='Lunch'?'MEAL':mealType).toUpperCase(),
                            qty:0,
                            teacherName:(teacher||'')=='undefined'?undefined:(teacher||''),
                            trxDate:systemDateTime,
                            transactionItems:[]
                        };
                        teacherGroup[teacher].map(rec=>{
                            const recObj={
                                menuItemId: rec.mealId,
                                qty:rec.totalQty
                            };
                            gradeObj.transactionItems.push(recObj);
                            gradeObj.mealType=(rec.mealType==='LUNCH'?'MEAL':rec.mealType).toUpperCase();;
                            gradeObj.qty=gradeObj.qty+rec.totalQty;    
                        });
                        finalReqObj.push(gradeObj);
                    })                    
                }                
            });
            setLoading(true);
             saveItemTransaction({
                schoolId,
                mealType,
                userId:loginUserInfo.userId,
                reqBody:finalReqObj
            }).then((response) => {
                if (response.status === 200) {
                    setLoading(false);                        
                    this.setState({ data:[], selectedRows:[], selection:[] })
                    _addNotification('Bulk transaction done successfully', this.props);
                    callback(true);
                    this.getData();
                } else if (!response.ok) {
                    throw Error(response.statusText);
                }
            }).catch(
                (error) => {
                    setLoading(false);
                    callback(true);
                    _addNotificationError('Bulk transaction failed ! Try again.', this.props);
                    console.log('Send Notification Error', error)
                }
            );

        }else{
            _addNotificationError('Please select at least one item.', this.props);
            callback(true);
        }
    }
    render() {
        const {gradeList, selectedDate, mealType}=this.props;
        const { selectAll, data, filterData, tabIndex, ttabIndex, teachers } = this.state;
        const { toggleSelection, toggleAll, isSelected } = this;
        const checkboxProps = {
            selectAll, 
            isSelected,
            toggleSelection,
            toggleAll,           
            selectType: "checkbox",
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        {
            $('#selector button').click(function () {
                $(this).addClass('active').siblings().removeClass('active');
            })
        }
        
        return (
            <Fragment>
                <Tabs selectedIndex={tabIndex} onSelect={(idx) => {
                                this.setState({ selectAll: false,tabIndex:idx, search:'' },()=>{
                                    this.filterOrderData(data, idx,0);;
                                });                               
                            }}>
                    <TabList>
                    {
                        gradeList.map((item)=> {
                            return <Tab > {item.label}</Tab>
                        }, this)
                    }
                    </TabList>
                    {
                        gradeList.map((grade,i)=>{
                            const teachersList=((teachers||{})[grade.value]||[]);
                            return(<TabPanel>
                                {
                                    teachersList.length>0?
                                    <div className="row">
                                    <div className='col-md-12 form-group'>
                                        <Tabs selectedIndex={ttabIndex} onSelect={(index) => {
                                                         this.setState({ selectAll: false, ttabIndex:index, search:'' },()=>{
                                                            this.filterOrderData(data, i, index);
                                                        });                                
                                                    }}>
                                            <TabList>
                                            {
                                                teachersList.map((teacher)=> {
                                                    return <Tab> {teacher}</Tab>
                                                }, this)
                                            }
                                            </TabList>
                                            {
                                                teachersList.map((teacher)=> {
                                                    return <TabPanel >
                                                        <div className="row">
                                                            <div className='col-md-12 form-group'>
                                                                <CustomSubmit id="addSchool" type="button" className="btn btn-success button-sm pull-right"
                                                                    style={{ margin: '0' }} 
                                                                    handleSubmit={(e,callback) => this.saveTransaction(e,callback)} >
                                                                        <i className="glyphicon glyphicon-ok"></i> Save Transaction</CustomSubmit>
                                                            </div>
                                                            <div className="col-xs-12">
                                                                <CheckboxTable id={i+1}
                                                                    ref={r => (this.checkboxTable = r)}
                                                                        data={filterData}
                                                                        columns={this.getCols()}
                                                                        defaultPageSize={10}
                                                                        className="-striped -highlight"
                                                                        {...checkboxProps}  minRows={0} />
                                                            </div>
                                                        </div>
                                                    </TabPanel>
                                                }, this)
                                            }

                                        </Tabs>
                                    </div>                                    
                                </div>:
                                <div className="row">
                                    <div className='col-md-12 form-group'>
                                        <div className="row">
                                                            <div className='col-md-12 form-group'>
                                                                <CustomSubmit id="addSchool" type="button" className="btn btn-success button-sm pull-right"
                                                                    style={{ margin: '0' }} 
                                                                    handleSubmit={(e,callback) => this.saveTransaction(e,callback)} >
                                                                        <i className="glyphicon glyphicon-ok"></i> Save Transaction</CustomSubmit>
                                                            </div>
                                                            <div className="col-xs-12">
                                                                <CheckboxTable id={i+1}
                                                                    ref={r => (this.checkboxTable = r)}
                                                                        data={filterData}
                                                                        columns={this.getCols()}
                                                                        defaultPageSize={10}
                                                                        className="-striped -highlight"
                                                                        {...checkboxProps}  minRows={0} />
                                                            </div>
                                                        </div>

                                    </div>
                                </div>


                                }
                                
                            </TabPanel>); 
                        })

                    }                                                   
                </Tabs>       
            </Fragment>
        );
    }
}

export default ItemListComponent;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Transactions/bulkTransactions/itemListComponent.js